import { IBankAccount } from 'typescript/interfaces/companies'
import { monthNames } from 'constants/misc'

export const getBankStatementFileName = (bankAccount: IBankAccount, month: string, year: number) =>
  `${bankAccount.bankName} ${month} ${year} ${bankAccount.bankAccount.slice(-4)}`

export interface IMonthWindowEntry {
  month: string
  year: number
  monthIndex: number
}

export const getRollingMonthWindow = (
  referenceDate: Date = new Date(),
  monthsBefore = 3,
  monthsAfter = 8,
): IMonthWindowEntry[] => {
  const total = monthsBefore + 1 + monthsAfter
  const startYear = referenceDate.getFullYear()
  const startMonth = referenceDate.getMonth() - monthsBefore
  return Array.from({ length: total }, (_, i) => {
    const d = new Date(startYear, startMonth + i, 1)
    const monthIndex = d.getMonth()
    return { month: monthNames[monthIndex], year: d.getFullYear(), monthIndex }
  })
}
